import styled, { keyframes } from "styled-components";

// Contêiner Principal
export const Container = styled.div`
  padding: 0px;
  margin-top: 16px;
`;

// Título
export const Title = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 300;
  margin-bottom: 16px;
`;

// Botões de Ação
export const AddButton = styled.button`
  background-color: #007bff;
  color: #fff;
  padding: 8px 12px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #0056b3;
  }
`;

export const ActionButton = styled.button`
  background-color: #ffc107;
  color: #fff;
  padding: 4px 8px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #e0a800;
  }
`;

export const ActionButtonOrder = styled.button`
  background-color: #ffc107;
  color: #fff;
  padding: 4px 8px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #e0a800;
  }
`;

// Animação para formulário
const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

// Contêineres de Formulário
export const FormContainer = styled.div`
  display: ${({ visible }) => (visible ? "block" : "none")};
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

export const FormInnerContainer = styled.div`
  background-color: #ffffff;
  width: 40%;

  padding: 32px;
  box-shadow: -2px 0 15px rgba(0, 0, 0, 0.2);
  animation: ${slideIn} 0.4s ease forwards;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  overflow-y: auto;
`;

// Inputs e Selects
export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
`;

export const Select = styled.select`
  width: 100%;
  padding: 7px;
  margin-bottom: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
`;

// Botões de Submissão e Cancelamento
export const SubmitButton = styled.button`
  background-color: #28a745;
  color: #fff;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #218838;
  }
`;

export const CancelButton = styled.button`
  background-color: #dc3545;
  color: #fff;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #c82333;
  }
`;

// Tabela e Cabeçalho da Tabela
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.th`
  padding: 12px;
  text-align: ${({ align }) => align || "left"};
  background-color: #f4f4f4;
  border-bottom: 2px solid #ddd;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: #333;
`;

// Células da Tabela
export const TableCell = styled.td`
  padding: 4px;
  width: ${({ width }) => (width ? `${width}px` : "auto")};
  border-bottom: 1px solid #eee;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #555;
  text-align: ${({ align }) => align || "left"};
  text-transform: uppercase;
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-top: 6px;
`;

export const TableWrapper = styled.div`
  background-color: #ffffff;
  padding: 22px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.03);
`;

// Linhas e Colunas
export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: ${({ mt }) => (mt ? `${mt}px` : "0")};
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : "0")};
`;

export const Column = styled.div`
  flex: ${({ cols }) => cols / 12 * 100}%;
  max-width: ${({ cols }) => cols / 12 * 100}%;
  padding: 0px 12px;
  box-sizing: border-box;
`;

// Paginação
export const PaginationButton = styled.button`
  padding: 8px 12px;
  margin: 0 4px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }

  &:disabled {
    background-color: #c0c0c0;
    cursor: not-allowed;
  }
`;

export const PageCounter = styled.span`
  margin: 0 8px;
  font-size: 11px;
  color: #555;
`;

// Pesquisa e Seleção de Status
export const SearchInput = styled.input`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 200px;
`;

export const StatusSelect = styled.select`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  margin-left: 8px;
`;

// Textarea
export const Textarea = styled.textarea`
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  resize: none;
`;

// Estilos específicos para Ordens de Trabalho
export const WorkOrderInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const WorkOrderInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const WorkOrderLabel = styled.span`
  font-weight: bold;
  color: #333;
  width: 50%;
`;

export const WorkOrderValue = styled.span`
  width: 50%;
  color: #555;
`;

export const WorkOrderTableContainer = styled.div`width: 100%;`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  margin-right: 8px;
  cursor: pointer;
  accent-color: #007bff;
`;
